import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";

import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

import { useLocation, useParams } from "react-router-dom"; // بدل route.params
import { useTranslation } from "react-i18next";
export default function Paiment() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [payments, setPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const { userId } = location.state; //
  const [user, setUser] = useState(null);
  const [canFetch, setCanFetch] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const fetchUser = useCallback(async () => {
    const token = localStorage.getItem("userToken");
    try {
      if (token) {
        const response = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
        // setMembership(response.data?.membership);
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    } finally {
      setCanFetch(true);
    }
  }, [baseUrl]);

  const fetchPayments = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${baseUrl}/payments`, {
        params: {
          id: userId ?? user?.id,
        },
      });


      setPayments(response.data.payments);

    } catch (error) {
      console.error("Error fetching payments:", error);
    } finally {
      setIsLoading(false);
    }
  }, [baseUrl]);

  useEffect(() => {
    fetchUser();

    if (userId) {
      fetchPayments();
    }
  }, [fetchPayments]);
  const displayedPayments = showAll ? payments : payments.slice(0, 3);

  return (
    
          <div className="bg-white shadow-custom bg-opacity-[87%] min-h-[50vh] md:h-full lg:h-full  flex flex-col justify-start items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
            {/* <div className="text-3xl md:text-4xl font-bold mb-2 md:mb-3">
              <p> {t("payments.payments")}</p>
            </div> */}
            <div className="text-2xl text-center  md:text-4xl lg:text-4xl  font-bold">
              {t("payments.history")}
            </div>

            <div className=" text-center p-6 md:p-16 rounded-3xl w-full h-full flex flex-col gap-6 md:gap-12">
              {/* <div className="text-3xl md:text-4xl font-bold">
                {t("payments.history")}
              </div> */}

              {isLoading ? (
                <div className="flex justify-center items-center h-64">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
                </div>
              ) : payments.length === 0 ? (
                <div className="text-gray-500 text-sm md:text-base">
                  {t("payments.no_payments")}
                </div>
              ) : (
                <div className="flex flex-col gap-4 md:gap-6">
                  {displayedPayments?.map((item) => (
                    <div
                      key={item.id}
                      className="flex flex-row md:flex-row justify-between items-start md:items-center bg-gray-100 px-4 py-3 md:px-6 md:py-4 rounded-lg shadow"
                    >
                      <div className="flex flex-col text-left mb-2 md:mb-0">
                        <div className="text-xs md:text-sm text-gray-600">
                          {new Date(item.created_at).toLocaleDateString()}
                        </div>
                        <div className="font-semibold  md:text-lg">
                          Upgrade Pack {item.motiv}
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="text-xs md:text-sm text-gray-500">
                          TTC
                        </div>
                        <div className="text-green-500 font-bold text-base md:text-lg">
                          {item.price} MAD
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {payments.length > 3 && (
                <div
                  onClick={() => setShowAll(!showAll)}
                  className="flex cursor-pointer flex-col gap-1 md:gap-2 justify-center items-center mt-3 md:mt-5"
                >
                  {!showAll && payments.length > 3 ? (
                    <IoIosArrowDown size={30} className="md:size-[50px]" />
                  ) : (
                    <IoIosArrowUp size={30} className="md:size-[50px]" />
                  )}

                  <div className="text-[#0D70A1] text-xl font-bold">
                    {!showAll && payments.length > 3
                      ? `${t("twichiyat.show")}`
                      : `${t("twichiyat.hide")}`}
                  </div>
                </div>
              )}
            </div>
          </div>
       
  );

  // return (
  //   <div
  //     className="flex flex-col gap-12 min-h-screen"
  //     style={{
  //       backgroundImage: `url(${images.golf_field})`,
  //       backgroundPosition: "center",
  //       backgroundSize: "cover",
  //       backgroundRepeat: "no-repeat",
  //       backgroundAttachment: "fixed",
  //     }}
  //   >
  //     <Nav />
  //     <div className="flex justify-center mx-16 mb-20">
  //       <div className="flex w-full justify-between items-start">
  //         <Sidebar />
  //         <div className="bg-white bg-opacity-[87%] h-full flex flex-col justify-center items-center p-16 gap-8 w-[75%] rounded-3xl py-16">
  //           <div className="text-center text-6xl font-bold mb-3">
  //             <p>Paiements</p>
  //           </div>

  //           <div className="bg-white text-center p-16 rounded-3xl w-full h-full flex flex-col gap-12">
  //             <div className="font-bold text-2xl">Historique des paiements</div>

  //             {isLoading ? (

  //               <div className="text-gray-500">Chargement des paiements...</div>
  //             ) : payments.length === 0 ? (
  //               <div className="text-gray-500">Aucun paiement trouvé.</div>
  //             ) : (
  //               <div className="flex flex-col gap-6">
  //                 {displayedPayments?.map((item) => (
  //                   <div
  //                     key={item.id}
  //                     className="flex justify-between items-center bg-gray-100 px-6 py-4 rounded-lg shadow"
  //                   >
  //                     <div className="flex flex-col text-left">
  //                       <div className="text-sm text-gray-600">
  //                         {new Date(item.created_at).toLocaleDateString()}
  //                       </div>
  //                       <div className="font-semibold">
  //                         Upgrade Pack {item.motiv}
  //                       </div>
  //                     </div>
  //                     <div className="text-right">
  //                       <div className="text-sm text-gray-500">TTC</div>
  //                       <div className="text-green-500 font-bold">
  //                         {item.price} MAD
  //                       </div>
  //                     </div>
  //                   </div>
  //                 ))}
  //               </div>
  //             )}
  //             {
  //               <div
  //                 onClick={() => setShowAll(!showAll)}
  //                 className="flex cursor-pointer flex-col gap-2 justify-center items-center mt-5"
  //               >
  //                 {!showAll && payments.length > 3 ? (
  //                   <IoIosArrowDown size={50} />
  //                 ) : (
  //                   <IoIosArrowUp size={50} />
  //                 )}

  //                 <div className="text-[#0D70A1] text-xl font-bold">
  //                   {!showAll && payments.length > 3
  //                     ? "Go to historical notifications"
  //                     : "Minimize"}
  //                 </div>
  //               </div>
  //             }
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
}
